import React, { useState } from "react";
import { Grid } from "@mui/material";
import { SelectField, MenuItem, Alert } from "@curves/ui-base";
import { checkIsManualTransferIn } from "@icoach/documents/tools";
import { MEMBERSHIP_TRANSFER_IN_FORM_CONTRACT_VERSION_QUIT_FEE_TIP } from "@icoach/constants/appConfig";
import { isEmpty } from "@util/utils";

/**
 * 移入申請書 下拉文書版本與提示訊息元件
 */
const MemberShipInformationVersionSelect = React.forwardRef((props, ref) => {
	const { sourceData: originalContractVersion, peopleType, isManual, options, readOnly = false } = props;
	const [version, setVersion] = useState(originalContractVersion || "");

	const handleContractVersionChange = (_e, _dom, value) => {
		setVersion(value);
	};

	return (
		<React.Fragment>
			<Grid xs={12} item>
				<Grid spacing={2} container>
					<Grid xs={4} item>
						<SelectField
							ref={ref}
							key={originalContractVersion}
							label="合約版本"
							value={version}
							onChange={handleContractVersionChange}
							disabled={!checkIsManualTransferIn(peopleType, isManual)}
							fullWidth
							displayEmpty
							readOnly={readOnly}
							required
						>
							<MenuItem value={""} disabled>
								<em>請選擇</em>
							</MenuItem>
							{options.map(item => (
								<MenuItem key={item.value} value={item.value} disabled={item.disabled}>
									{item.text}
								</MenuItem>
							))}
						</SelectField>
					</Grid>
				</Grid>
			</Grid>
			{!isEmpty(version) && (
				<Grid xs={12} item>
					<Alert severity="info" variant="filled" color="info">
						{MEMBERSHIP_TRANSFER_IN_FORM_CONTRACT_VERSION_QUIT_FEE_TIP[version]}
					</Alert>
				</Grid>
			)}
		</React.Fragment>
	);
});

export default MemberShipInformationVersionSelect;
